import { authFetch } from "./authApi";

async function requestJson(path, options = {}) {
  const response = await authFetch(path, options);
  if (!response.ok) {
    const body = await response.text();
    throw new Error(`API ${response.status} on ${path}: ${body || response.statusText}`);
  }
  return response.json();
}

export async function fetchNotificationSettings() {
  return requestJson("/notifications/settings", { method: "GET" });
}

export async function updateNotificationSettings(payload) {
  return requestJson("/notifications/settings", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
}

export async function fetchDueReminders(lookaheadMinutes = 2) {
  return requestJson(`/notifications/due?lookahead_minutes=${encodeURIComponent(lookaheadMinutes)}`, {
    method: "GET",
  });
}

export async function acknowledgeReminders(deliveryIds) {
  return requestJson("/notifications/ack", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ delivery_ids: deliveryIds }),
  });
}

export async function fetchDispatcherStatus() {
  return requestJson("/notifications/dispatcher/status", { method: "GET" });
}

export async function sendWhatsAppTestNotification(payload = {}) {
  return requestJson("/notifications/test/whatsapp", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
}
